export { default as Match } from './Match';



// WEBPACK FOOTER //
// ./src/common/app/components/index.js